import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-section-header-toggle': {
    'en-US': 'Toggle',
  },
};

export default katTranslator(strings);
